export default __webpack_public_path__ + "static/media/Bandit's Boots of the Covert Trail.728dc602.jpg";